import { IconProps } from './types';

const AllocationStatusIcon = (props: IconProps) => {
  const { size = 54, fillColor = 'var(--blue-bg)' } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="27" cy="27" r="27" fill={fillColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.9998 32.0835C33.3207 32.0835 33.5832 32.346 33.5832 32.6669V35.0002C33.5832 35.321 33.3207 35.5835 32.9998 35.5835C32.679 35.5835 32.4165 35.321 32.4165 35.0002V32.6669C32.4165 32.346 32.679 32.0835 32.9998 32.0835ZM32.994 29.1669C29.774 29.1669 27.1665 31.7802 27.1665 35.0002C27.1665 38.2202 29.774 40.8335 32.994 40.8335C36.2198 40.8335 38.8332 38.2202 38.8332 35.0002C38.8332 31.7802 36.2198 29.1669 32.994 29.1669ZM32.9998 39.6669C30.4215 39.6669 28.3332 37.5785 28.3332 35.0002C28.3332 32.4219 30.4215 30.3335 32.9998 30.3335C35.5782 30.3335 37.6665 32.4219 37.6665 35.0002C37.6665 37.5785 35.5782 39.6669 32.9998 39.6669ZM33.5832 37.9169H32.4165V36.7502H33.5832V37.9169Z"
        fill="#0276FE"
      />
      <path
        d="M31.3281 15.0002H15.2524C15.1101 15.0002 14.9995 15.1109 14.9995 15.2532V34.4745"
        stroke="#0276FE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M24.2468 38.2203H18.8408C18.6985 38.2203 18.5879 38.1096 18.5879 37.9674V18.8567C18.5879 18.7144 18.6985 18.6038 18.8408 18.6038H34.1104C34.2526 18.6038 34.3633 18.7144 34.3633 18.8567V25.6798"
        stroke="#0276FE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};
export default AllocationStatusIcon;
